import React from 'react';
import PropTypes from 'prop-types';

import { FormModal, Edit03Icon } from '@metarouter-private/mr-mui';

import useEditTag from './useEditTag';
import TagLabelField from './TagLabelField';

export default function EditTagForm({ open, onClose, tag }) {
  const { onSubmit } = useEditTag({ tag, onClose });

  return (
    <FormModal
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      title="Edit Tag"
      TitleIcon={Edit03Icon}
      submitLabel="Save"
      validationMode="onChange"
      defaultValues={{ label: tag.label }}
    >
      <TagLabelField defaultValue={tag.label} excludeLabel={tag.label} />
    </FormModal>
  );
}

EditTagForm.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  tag: PropTypes.object.isRequired,
};
